// extracted by mini-css-extract-plugin
export default {"add_topic__wrapper":"styles_add_topic__wrapper__pGUt3"};